import { get, post, put, del } from 'utils/methods';

export function getConfigurationsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}configuration`, data, headers);
}

export function addNewConfigurationApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/configuration`, data, headers);
}

export function editConfigurationApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/configuration`, data, headers);
}

export function updateTranslateConfigurationApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/configuration/translate`, data, headers);
}

export function addPropertyToConfigurationApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/configuration/property`, data, headers);
}

export function deletePropertyFromConfigurationApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}commands/configuration/property`, data, headers);
}

export function toggleConfigurationStatusApi(action, data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/configuration/${action}`, data, headers);
}
